module.exports = __webpack_public_path__ + "a79ca0748ec3b858107e8a2565920447.svg";